import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useAuth } from "hooks/Auth";
import LoaderShell from "./Shells/LoaderShell";
import { oauthDel } from "helpers/Request";
import {
    removeOauthRefreshToken,
    removeOauthToken,
    removePublicationUuid,
    removePublicationCode,
} from "helpers/Auth";
import MainLayout from "./DesignSystem/MainLayout";
import { initializeContentFlow } from "redux/actions/content-flow";
import { KBarProvider } from "kbar";
import CommandMenu from "./CommandMenu";
import { useAsyncError } from "hooks/AsyncError";
import CustomToaster from "./Toast/CustomToaster";
import CustomModal from "./HeadlessModal/CustomModal";

const mapStateToProps = (state) => {
    return {
        contentFlow: state.contentFlow,
    };
};

export default connect(mapStateToProps, { initializeContentFlow })(
    function ApplicationShell({ children, ...props }) {
        // const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
        const [appLoaded, setAppLoaded] = useState(false);
        const { initializeContentFlow } = props;

        const auth = useAuth();
        const throwError = useAsyncError();
        const startRef = useRef(false);

        const requestLogout = () => {
            setAppLoaded(false);

            oauthDel("api/v2/me").then((res) => {
                removeOauthRefreshToken();
                removeOauthToken();
                window.location.href =
                    process.env.REACT_APP_OAUTH_SERVER +
                    "/auth/v2/deauthenticate";
            });
        };
        const requestPublicationChange = () => {
            removePublicationUuid();
            removePublicationCode();
            window.location.reload();
        };

        // only fire this once
        useEffect(() => {
            if (startRef.current === false && auth.isAuthenticated) {
                // initialize content flow redux store
                // this adds workflows and status to the store
                startRef.current = true;
                console.info("Initialize content flow");
                initializeContentFlow()
                    .then(() => {
                        setAppLoaded(true);
                    })
                    .catch((e) => {
                        throwError(
                            new Error(
                                "Unable to connect to CEO the server. It may be down or there may be a network issue.",
                                { cause: e }
                            )
                        );
                    });
            }

            return () => {
                startRef.current = false;
                setAppLoaded(false);
            };
        }, [auth.isAuthenticated, initializeContentFlow, throwError]);

        if (!appLoaded) {
            return <LoaderShell statusMessage="Loading CEO..." />;
        }

        return (
            <div
                onDragStart={props.onDragStart}
                onDragEnd={props.onDragEnd}
                onDragEnter={props.onDragEnter}
            >
                <KBarProvider>
                    <MainLayout
                        user={auth.user}
                        requestPublicationChange={requestPublicationChange}
                        requestLogout={requestLogout}
                        requestShowDropzone={props.requestShowDropzone}
                    >
                        {children}
                    </MainLayout>
                    <CommandMenu />
                    <CustomToaster />
                    <CustomModal />
                </KBarProvider>
            </div>
        );
    }
);
